import createVueApp from '@/common/createApp'

Styxie.Initializers.StatsKeywords = {
  index: async(props) => {
    const { default: Keywords } = await import('@/vue_widgets/locations/keywords')
    createVueApp(Keywords, {
      props: {
        keywordsData: { ...props, isPublic: true }
      }
    })
  }
}
